import { atom } from "jotai";
import { CreditDocumentUploadResponse } from "@/core/repositories/credit";

export interface CreditUploadDocument {
  processId: number;
  file: File;
  isPending: boolean;
  isUploading: boolean;
  isUploaded: boolean;
  error: string | null;
  type: {
    label: string;
    value: string;
  } | null;
  response: CreditDocumentUploadResponse | null;
}

export interface CreditDocumentUploadState {
  isDocumentUploadOpen: boolean;
  selectedModalId: number | null;
  documents: CreditUploadDocument[];
  isAttaching: boolean;
}

const initialState: CreditDocumentUploadState = {
  isDocumentUploadOpen: false,
  selectedModalId: null,
  documents: [],
  isAttaching: false,
};

export const creditDocumentUploadAtom = atom<CreditDocumentUploadState>(initialState);

export const isCreditDocumentUploadOpenAtom = atom(get => get(creditDocumentUploadAtom).isDocumentUploadOpen);
export const creditUploadDocumentsAtom = atom(get => get(creditDocumentUploadAtom).documents);
export const isCreditAttachingAtom = atom(get => get(creditDocumentUploadAtom).isAttaching);
export const creditUploadSelectedModalIdAtom = atom(get => get(creditDocumentUploadAtom).selectedModalId);
